import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { zodResolver } from '@hookform/resolvers/zod';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { z } from 'zod';
import { AuthLayout } from '@/components/AuthLayout';
import { api } from '@/lib/api';
import { useAuthStore } from '@/stores/auth';
const schema = z.object({ code: z.string().min(6).max(10) });
export function TwoFactorChallengePage() {
    const location = useLocation();
    const navigate = useNavigate();
    const setAccessToken = useAuthStore((s) => s.setAccessToken);
    const [serverError, setServerError] = useState(null);
    const challengeToken = location.state?.challengeToken;
    const form = useForm({ resolver: zodResolver(schema), defaultValues: { code: '' } });
    const mutation = useMutation({
        mutationFn: async (values) => {
            const res = await api.post('/auth/2fa/verify/', {
                challenge_token: challengeToken,
                code: values.code,
            });
            return res.data;
        },
        onSuccess: (data) => {
            setAccessToken(data.access);
            navigate('/', { replace: true });
        },
        onError: (err) => {
            setServerError(err.response?.data?.error?.message ?? 'Invalid code.');
        },
    });
    if (!challengeToken)
        return _jsx(Navigate, { to: "/login", replace: true });
    return (_jsx(AuthLayout, { title: "Two-factor authentication", subtitle: "Enter the 6-digit code from your authenticator.", children: _jsxs("form", { className: "space-y-4", onSubmit: form.handleSubmit((v) => mutation.mutate(v)), children: [_jsxs("div", { className: "space-y-1", children: [_jsx("label", { htmlFor: "code", className: "text-sm font-medium", children: "Code" }), _jsx("input", { id: "code", type: "text", inputMode: "numeric", autoFocus: true, autoComplete: "one-time-code", className: "block w-full rounded-md border border-input bg-background px-3 py-2 text-center font-mono text-lg tracking-widest", ...form.register('code') }), form.formState.errors.code && (_jsx("p", { className: "text-xs text-destructive", children: form.formState.errors.code.message }))] }), serverError && _jsx("p", { className: "text-xs text-destructive", children: serverError }), _jsx("button", { type: "submit", className: "w-full rounded-md bg-primary px-3 py-2 text-sm font-medium text-primary-foreground disabled:opacity-50", disabled: mutation.isPending, children: mutation.isPending ? 'Verifying…' : 'Verify' }), _jsx("p", { className: "text-center text-xs text-muted-foreground", children: "Lost your device? Use a backup code instead." })] }) }));
}
